<script>
    import { onMount, getContext } from 'svelte';
    import { axisTop } from 'd3-axis';
    import { select } from 'd3-selection';
    import { scaleLinear, scaleSequential } from 'd3-scale';
    import { interpolateBlues, interpolateOranges } from 'd3-scale-chromatic';

    // --- Properties
    export let dataKey;
    const { 
        matches, sortField, sortDescending, activeMatch: active, 
        hoverMatch, unhoverMatch 
    } = getContext(dataKey);
      
    const width = 75;

    // --- Scales
    const widthScale = scaleLinear([0, width/2]);
    const precisionColor = scaleSequential(interpolateOranges);
    const recallColor = scaleSequential(interpolateBlues);

    // --- Axes
    let precisionAxis;
    let recallAxis;

    onMount(() => {
        const tickLabels = ['0', '0.5', '1']
        select(precisionAxis)
          .attr('transform', 'translate(0, 20)')
          .call(axisTop(scaleLinear([width/2, 0]))
            .ticks(3)
            .tickFormat((d, i) => tickLabels[i]))
          .call(g => g.select('.domain').remove());
        select(recallAxis)
          .attr('transform', 'translate(0,20)')
          .call(axisTop(scaleLinear([width/2, width]))
            .ticks(2)
            .tickValues([0.5, 1])
            .tickFormat((d, i) => tickLabels[i+1]))
          .call(g => g.select('.domain').remove());
    });

    // --- Sorting    

    function changeSort(field) {
        if ($sortField !== field) {
            $sortDescending = true;
            $sortField = field;
        } else {
            $sortDescending = !$sortDescending;
        }
    }
</script>


<div id='matches' style='flex-basis:{width}px;max-width:{width}px'>
    <div class='header'>
        <span style='width:{width}px' on:click={() => changeSort('num_matches')}>Matches</span>
    </div>
    <div class='buttons'>
        <span on:click={() => changeSort('precision')}>pr</span>
        <span on:click={() => changeSort('recall')}>rc</span>
    </div>
    <svg class='axes' height='20px'>
        <g bind:this={precisionAxis}></g>
        <g bind:this={recallAxis}></g>
    </svg>
    {#each $matches as m, i}
        <div class='match'
             class:fade={!$active[i]}
             on:mouseenter={() => hoverMatch(m) }
             on:mouseleave={() => unhoverMatch(m) }>
            <div style='width:{widthScale(1-Math.min(m.precision, 1))}px;'></div>
            <div style='width:{widthScale(Math.min(m.precision, 1))}px;background-color:{precisionColor(m.precision)}'>
            </div>
            <div style='width:{widthScale(Math.min(m.recall, 1))}px;background-color:{recallColor(Math.min(m.recall, 1))}'>
            </div>
            <!-- <div style='width:{widthScale(1-m.recall)}px;'></div> -->
        </div>
    {/each}
</div>


<style>
    #matches {
        display: flex;
        flex-grow: 0;
        flex-shrink: 0;
        flex-direction: column;
    }

    #matches div {
        display: flex;
        flex-direction: row;
        flex-shrink: 0;
        flex-grow: 0;
    }
    
    .header {
        height: 20px;
        margin-bottom: 10px;
    }

    .header span {
        line-height: 20px;
        display: block;
        text-align: center;
        cursor:pointer;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .buttons {
        height: 15px;
        font-size: 15px;
        margin-bottom: 9px!important;
    }

    .buttons span {
        width: 50%;
        display: block;
        text-align: center;
        cursor:pointer;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        line-height: 15px;
    }

    #matches svg {
        overflow: visible;
        margin-bottom: 6px;
    }

    .match {
        background-color: #ddd;
        height: 10px;
        margin-top: 0px;
        margin-bottom: 10px;
        cursor: pointer;
    }

    .match.fade {
        opacity: 0.5;
    }

    .match div {
        position: relative;
        height: 100%;
    }
</style>